const host = 'https://classes-app.onrender.com/api/v1';
export default host;
